module.exports = __webpack_public_path__ + "images/檀程长图_06-2.jpg?v=dd1ab91a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_06-2.jpg
 ** module id = 192
 ** module chunks = 1 2
 **/